(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["candor-whatsapp"] && !Shopify.designMode) return;
  try {
    (() => {
  const initializeWhatsApp = () => {
    const link = document.querySelector('.candor-whatsapp');
    if (!link || link.dataset.introInitialized === 'true') return;
    link.dataset.introInitialized = 'true';
    const storageKey = 'candor.whatsapp.intro.v1';
    const delay = 5000;
    const duration = 5000;
    let firstVisit = Date.now();
    let seen = false;
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (saved && Number.isFinite(saved.firstVisit)) {
        firstVisit = saved.firstVisit;
        seen = saved.seen === true;
      } else {
        sessionStorage.setItem(storageKey, JSON.stringify({ firstVisit, seen: false }));
      }
    } catch {}
    if (seen) return;
    const reveal = () => {
      if (document.visibilityState === 'hidden') {
        document.addEventListener('visibilitychange', revealWhenVisible);
        return;
      }
      link.classList.add('is-introducing');
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({ firstVisit, seen: true }));
      } catch {}
      window.setTimeout(() => link.classList.remove('is-introducing'), duration);
    };
    const revealWhenVisible = () => {
      if (document.visibilityState === 'hidden') return;
      document.removeEventListener('visibilitychange', revealWhenVisible);
      reveal();
    };
    window.setTimeout(reveal, Math.max(0, delay - (Date.now() - firstVisit)));
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeWhatsApp, { once: true });
  } else {
    initializeWhatsApp();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
